import React from 'react'
import RolesDataTable from "./RolesDataTable";

function RolesDataPage(props) {
    const {innerHeight} = props

    return <div className="RolesDataPage">
        <div className="PageHeading align-items-end">
            <h5 className="mb-0">Phân quyền dữ liệu</h5>
            {/*<SaveRolesData/>*/}
        </div>
        <div className="PageTable" style={{maxHeight: (parseInt(innerHeight) - 350) / 2 + 'px', overflow: 'auto'}}>
            <RolesDataTable/>
        </div>
    </div>
}

export default RolesDataPage
